
    export const UserStyles = {
        marginLeft: "auto",
        marginRight: "auto",
        marginBottom: (theme) => theme.spacing(2)
    },
    UserNameStyles = {
        marginTop: "8px",
        marginLeft: "14px",
        marginBottom: "8px"
    },
    DropdownStyles = {
        marginTop: (theme) => theme.spacing(1),
        marginBottom: (theme) => theme.spacing(4)
    },
    AuthorizationTitleStyles = {
        marginBottom: (theme) => theme.spacing(1)
    },
    AuthorizationItemStyles = {
        marginLeft: (theme) => theme.spacing(3)
    }
